import {
  StyledDescription,
  StyledPromoBanner,
  StyledTitle,
} from './PromoBanner.styles'
import { promoBannerTheme } from './PromoBannerThemes'

interface PromoBannerProps {
  brand: keyof typeof promoBannerTheme
  translations: {
    title: string
    description: string
  }
}
export function PromoBanner({
  brand,
  translations,
}: PromoBannerProps): JSX.Element {
  return (
    <StyledPromoBanner
      $backgroundColor={promoBannerTheme[brand].backgroundColor}
      $fontColor={promoBannerTheme[brand].fontColor}
    >
      <StyledTitle>{translations.title}</StyledTitle>
      <StyledDescription>{translations.description}</StyledDescription>
    </StyledPromoBanner>
  )
}
